import { render, staticRenderFns } from "./AddAdminUser.vue?vue&type=template&id=a5d37c6a&"
import script from "./AddAdminUser.vue?vue&type=script&lang=js&"
export * from "./AddAdminUser.vue?vue&type=script&lang=js&"
import style0 from "./AddAdminUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddAdminUser.vue"
export default component.exports